export default __webpack_public_path__ + "static/media/fisica.23a875e3.svg";